import React from 'react';
import { Offices } from 'components/offices/Offices';
import { OfficesItem } from 'components/offices/OfficesItem';
import { RichText } from 'components/rich-text/RichText';

export const RichTextSlice = ({ title, image, display, items }) => {
  return (
    <Offices title={title} image={image} display={display} isSlice>
      {items?.map((item, index) => (
        <OfficesItem
          key={index}
          title={item.title}
          text={RichText.render(item.text)}
          hasAddress={item.hasAddress}
          address={RichText.render(item.address)}
          phone={item.phone}
          fax={item.fax}
          email={item.email}
        />
      ))}
    </Offices>
  );
};

export default RichTextSlice;
